import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=5c86146c&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=js"
export * from "./fileUpload.vue?vue&type=script&lang=js"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=5c86146c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_658dcddb1d89a08c03476f5e8f9c1110/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86146c",
  null
  
)

export default component.exports